module.exports = __webpack_public_path__ + "img/swift-glx-gris-acero.2840b5b7.png";